/**
 * Renders a view which displays a list of `Organization` models.
 * ## Field
 * Name | Description
 * --- | ---
 * table | The underlying `CollectionTableView` containing the displayed data.
 * @module app/views/admin/organizations/Index
 */
import Backbone from "backbone";
import _ from "underscore";
import CollectionTableView from "core/views/CollectionTableView";
import Field from "core/models/Field";
import Organization from "app/models/Organization";
export default Backbone.View.extend({
  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {OrganizationCollection} options.models The collection of `Organization` models to display.
   */
  initialize: function (options) {
    this.options = options;
  },

  template: _.template('<table id="org-table" class="table"></table>'),
  className: "organization-index",

  render: function () {
    var fields = [
      new Field(Organization.fields["PrimaryName"]).decorate({
        id: "id",
        name: "id",
        filterable: "PrimaryName",
        viewOptions: {
          type: "link",
          linkField: "PrimaryName",
          linkUrl: "admin/organizations/Details",
        },
      }),
      new Field(Organization.fields["Address"]),
      new Field(Organization.fields["PhoneNumber"]),
      new Field(Organization.fields["EmailAddress"]),
    ];

    this.$el.html(this.template(this.options));

    var table = (this.table = new CollectionTableView({
      fields: fields,
      el: this.$("#org-table"),
      collection: this.options.models,
      allowSave: false,
      allowDelete: false,
      mode: "view",
    }));

    table.render();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/organizations/Index.js
// module id = 921
// module chunks = 1